import { createSlice } from '@reduxjs/toolkit'

const stageSlice = createSlice({
	name: 'stage',
	initialState: {
		stage: {
			levels: []
		},
		immutableState: []
	},
	reducers: {
		setStageData(state, action) {
			state.stage = action.payload
		},
		setImmutableState(state, action) {
			state.immutableState = action.payload
		},
		setStageLevels(state, action) {
			state.stage.levels = action.payload
		},
		addParticipant(state, action) {
			const { levelIndex, groupIndex, node } = action.payload
			state.stage.levels[levelIndex].groups[groupIndex].nodes.push(node)
		},
		removeParticipant(state, action) {
			state.stage.levels = action.payload
		},
		dragParticipant(state, action) {
			const { obj } = action.payload
			state.stage.levels[obj.sourceLevelIndex].groups[obj.sourceGroupIndex].nodes[obj.sourcePlaceIndex] = obj.replacedNode
			state.stage.levels[obj.endLevelIndex].groups[obj.finishGroupIndex].nodes[obj.finishPlaceIndex] = obj.movedNode
		},
		replaceParticipant(state, action) {
			state.stage.levels  = action.payload
		},
		updateParticipantNumber(state, action) {
			const { levelIndex, groupIndex, number } = action.payload
			state.stage.levels[levelIndex].groups[groupIndex].participants_count = number
		},
		updateGroupNodes(state, action) {
			const { levelIndex, groupIndex, levels, index, addedNode } = action.payload
			state.stage.levels = levels
			state.stage.levels[levelIndex].groups[groupIndex].nodes.splice(index, 0, addedNode)
		},
		updateGroupName(state, action) {
			const { levelIndex, groupIndex, groupName } = action.payload
			state.stage.levels[levelIndex].groups[groupIndex].name = groupName
		},
		addLevel(state, action) {
			state.stage.levels.push(action.payload)
		},
		removeLevel(state, action) {
			state.stage.levels = action.payload
		},
		addGroup(state, action) {
			const { levelIndex, group } = action.payload
			state.stage.levels[levelIndex].groups.push(group)
		},
		removeGroup(state, action) {
			const { levelIndex, groupIndex } = action.payload
			state.stage.levels[levelIndex].groups.splice(groupIndex, 1)
		}
	}
})

export const {
	setStageData,
	addParticipant,
	removeParticipant,
	updateGroupNodes,
	updateGroupName,
	updateParticipantNumber,
	addLevel,
	addGroup,
	removeLevel,
	removeGroup,
	dragParticipant,
	replaceParticipant,
	setStageLevels,
	setImmutableState
} = stageSlice.actions
export default stageSlice.reducer